<template>
    <restaurant-reviews-widget-section
        class="restaurant-reviews-widget-section"
        :title="attributes.restaurantReviewsWidgetSection_title"
        :token="attributes.token"
        :widget-id="attributes.widget_id"
    />
</template>

<script>
    import RestaurantReviewsWidgetSection from '../../../organisms/RestaurantReviewsWidgetSection/RestaurantReviewsWidgetSection.vue';

    export default {
        name: 'restaurant-reviews-widget-section-module',

        components: { RestaurantReviewsWidgetSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>
